import { createContext, useContext } from "react";
import { SidebarHookProps } from "./Sidebar.types.js";

export const SidebarContext = createContext<SidebarHookProps>({} as SidebarHookProps);

export const useSidebar = () => useContext(SidebarContext);
